import type { CommitteeMember, MemberSummary, TeamCompetition } from '../types/api.types';
import type { MemberLookupFn } from '../utils/committee';
import { useState } from 'react';
import CurrentCommittee from './current-committee';
import CommitteeHistoryTable from './committee-history-table';
import DueCommitteeRoleTable from './due-committee-role-table';

interface CommitteeProps {
  committeeMembers: CommitteeMember[];
  memberLookup: MemberLookupFn;
  memberSummaries: MemberSummary[];
  teamCompetitions: TeamCompetition[];
}

type TabMode = 'history' | 'due';

export default function Committee({
  committeeMembers,
  memberLookup,
  memberSummaries,
  teamCompetitions,
}: CommitteeProps) {
  const [activeTab, setActiveTab] = useState<TabMode>('history');

  return (
    <>
      <CurrentCommittee committeeMembers={committeeMembers} memberLookup={memberLookup} />

      <div className="aboutpage" style={{ marginTop: '50px' }}>
        <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', borderBottom: '2px solid #dee2e6' }}>
          <button
            onClick={() => setActiveTab('history')}
            style={{
              padding: '12px 24px',
              backgroundColor: 'transparent',
              color: activeTab === 'history' ? '#0066cc' : '#666',
              border: 'none',
              borderBottom: activeTab === 'history' ? '3px solid #0066cc' : '3px solid transparent',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: activeTab === 'history' ? 'bold' : 'normal',
              transition: 'all 0.2s',
            }}
          >
            Committee History
          </button>
          <button
            onClick={() => setActiveTab('due')}
            style={{
              padding: '12px 24px',
              backgroundColor: 'transparent',
              color: activeTab === 'due' ? '#0066cc' : '#666',
              border: 'none',
              borderBottom: activeTab === 'due' ? '3px solid #0066cc' : '3px solid transparent',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: activeTab === 'due' ? 'bold' : 'normal',
              transition: 'all 0.2s',
            }}
          >
            Due Committee Role
          </button>
        </div>

        {activeTab === 'history' && (
          <CommitteeHistoryTable committeeMembers={committeeMembers} memberLookup={memberLookup} />
        )}

        {activeTab === 'due' && (
          <DueCommitteeRoleTable
            committeeMembers={committeeMembers}
            memberSummaries={memberSummaries}
            teamCompetitions={teamCompetitions}
          />
        )}
      </div>
    </>
  );
}
